import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import PageLayout from '../../Components/pageLayout';
import './index.less';

import qrcode from '../../static/qrcode.webp';

const Contact: React.FC = () => {
    const history = useHistory();
    const mapInitialized = useRef(false);


    useEffect(() => {
        if (mapInitialized.current) return;
        mapInitialized.current = true;
        const script = document.createElement('script');
        script.src = `https://map.qq.com/api/gljs?v=2.exp&key=${process.env.REACT_APP_TENCENT_MAP_KEY}`;
        document.body.appendChild(script);

        script.onload = () => {
            if (!window.TMap) {
                console.error('腾讯地图SDK未正确加载');
                return;
            }

            try {
                // 初始化地图
                const center = new window.TMap.LatLng(30.223367, 119.987892); // 杭州市西湖区坐标
                const map = new window.TMap.Map('map-container', {
                    center: center,
                    zoom: 15,
                });

                // 检查Marker类是否存在
                if (!window.TMap.MultiMarker) {
                    throw new Error('腾讯地图MultiMarker类未定义');
                }

                if (!window.TMap.MultiLabel) {
                    throw new Error('腾讯地图MultiLabel类未定义');
                }
                // 添加点标记
                new window.TMap.MultiMarker({
                    map: map,
                    geometries: [{
                        position: center,
                    }],
                });

                // 添加文字标记
                new window.TMap.MultiLabel({
                    id: 'label-layer',
                    map: map,
                    styles: {
                        'label': new window.TMap.LabelStyle({
                            color: '#000',
                            fontSize: 14,
                            backgroundColor: '#fff',
                            padding: '5px 10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            offset: { x: 0, y: 30 },
                            wrapOptions: {
                                maxWidth: 200
                            }
                        })

                    },
                    geometries: [{
                        position: center,
                        content: '绿城爱心教育基金会\n杭州市余杭区闲林街道联荣路1-65号四楼',
                        styleId: 'label',
                        id: 'label'
                    }],
                });

                mapInitialized.current = true;
            } catch (error) {
                console.error('地图初始化失败:', error);
            }
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);



    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>联系我们</h1>
                <div className='contact-content'>
                    <div id="map-container" style={{ width: '100%', height: '400px' }}></div>
                </div>
                <div className='contact-info' style={{ textAlign: 'center' }}>
                    <h2>联系人信息</h2>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <span>李莉</span>
                        <span>电话：18857167980</span>
                    </div>
                </div>
                <div className='qr-code' style={{ textAlign: 'center' }}>
                    <h2>扫码关注微信公众号</h2>
                    <img src={qrcode} alt="二维码" style={{ width: '200px', height: '200px' }} />
                </div>
            </div>
        } />
    );
};

export default Contact;